import { Observable } from 'rxjs'
import { MbPaymentMode } from '../../../models'

export abstract class MbPaymentModeAdapter {

  abstract load(cartID: string): Observable<MbPaymentMode[]>
}
